document.addEventListener("DOMContentLoaded", function () {
  const productForm =
    document.querySelector("form.product-single__form") ||
    document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  window.__customValidationErrors = window.__customValidationErrors || [];
  window.__customValidation = window.__customValidation || {};
  window.__customValidation.blocked = false;

  window.__triggerAllCustomWarnings = function () {
    // CUSTOM-NAME
    if (window.__customValidation.cardNameValid === false) {
      if (
        window.__customNameComponent &&
        window.__customNameComponent.showWarning
      ) {
        window.__customNameComponent.showWarning();
      }
    }

    // CUSTOM-PHONE
    if (window.__customValidation.cardPhoneValid === false) {
      if (
        window.__customPhoneComponent &&
        window.__customPhoneComponent.showWarning
      ) {
        window.__customPhoneComponent.showWarning();
      }
    }

    // CUSTOM-DETAILS
    if (window.__customValidation.cardDetailsValid === false) {
      if (
        window.__customDetailsComponent &&
        window.__customDetailsComponent.showWarning
      ) {
        window.__customDetailsComponent.showWarning();
      }
    }

    // CUSTOM-UPLOAD
    if (window.__customValidation.cardUploadValid === false) {
      if (
        window.__customUploadComponent &&
        window.__customUploadComponent.showWarning
      ) {
        window.__customUploadComponent.showWarning();
      }
    }
    // CUSTOM-FISH
    if (window.__customValidation.cardFishValid === false) {
      if (
        window.__customFishComponent &&
        window.__customFishComponent.showWarning
      ) {
        window.__customFishComponent.showWarning();
      }
    }
  };
  //
  productForm
    .querySelectorAll('button[type="submit"], input[type="submit"]')
    .forEach((btn) => {
      btn.addEventListener(
        "click",
        (ev) => {
          window.__lastSubmissionId = Date.now().toString();
          window.__customValidationErrors = [];
          window.__customValidation.blocked = false;
          window.__triggerAllCustomWarnings();
          const clickEvent = ev;

          function processSubmit() {
            if (
              window.__customValidationErrors &&
              window.__customValidationErrors.length > 0
            ) {
              clickEvent.preventDefault();
              clickEvent.stopImmediatePropagation();
              window.__customValidation.blocked = true;
              return;
            }

            document
              .querySelectorAll("[data-custom-toggle]")
              .forEach((toggle) => {
                if (!toggle.checked) {
                  const target = toggle.dataset.target;
                  if (!target) return;
                  productForm
                    .querySelectorAll(
                      `.custom-mirror-input[data-origin="${target}"]`,
                    )
                    .forEach((m) => (m.name = ""));
                }
              });
          }

          processSubmit();
        },
        { capture: true },
      );
    });
  // finish block

  productForm.addEventListener("formdata", (ev) => {
    document.querySelectorAll("[data-custom-toggle]").forEach((toggle) => {
      if (!toggle.checked) {
        const target = toggle.dataset.target;
        if (!target) return;
        const keys = Array.from(ev.formData.keys());
        keys.forEach((k) => {
          if (k.startsWith("properties[") && k.includes(target)) {
            ev.formData.delete(k);
          }
        });
      }
    });
  });

  // for procuts with extra products
  const extraProducts = [];

  function registerExtraProduct(variantId, qty, props = {}) {
    const submissionId = window.__lastSubmissionId;
    extraProducts.push({
      variantId: variantId,
      qty,
      props: {
        ...props,
        bundleInstance: submissionId,
      },
    });
  }
  // end

  function getVisibleInputs() {
    return Array.from(
      document.querySelectorAll(
        '.upload-new-image-box input[type="file"], .photo-upload-input, #personalized-textarea, #personalized-extra-price',
      ),
    );
  }

  const mirrorMap = new Map();

  function createHiddenInputFor(visibleInput) {
    const hidden = document.createElement("input");
    hidden.type = visibleInput.type === "file" ? "file" : "hidden";
  
    hidden.style.display = "none";
    hidden.className = "custom-mirror-input";
    hidden.name = visibleInput.name || "";
    hidden.dataset.origin = visibleInput.dataset.toggleGroup || "";
    visibleInput.addEventListener("change", () => {
      hidden.dataset.origin = visibleInput.dataset.toggleGroup || "";
    });
    productForm.appendChild(hidden);
    return hidden;
  }

  function copyFilesToHidden(visible, hidden) {
    try {
      const files = visible.files;
      const dt = new DataTransfer();
      if (!files || files.length === 0) {
        hidden.value = "";
        return;
      }
      for (let i = 0; i < files.length; i++) dt.items.add(files[i]);
       hidden.files = dt.files;

    } catch (err) {
      console.error("Error copying files to hidden input", err);
    }
  }

  getVisibleInputs().forEach((v) => {
    const h = createHiddenInputFor(v);
    mirrorMap.set(v, h);
    if (v.type === "file") {
      v.addEventListener("change", () => copyFilesToHidden(v, h));
    } else {
      v.addEventListener("input", () => {
        h.value = v.value;
        h.name = v.name;
      });
    }
  });

  // --- CUSTOM-CARD-DETAILS ---
  const cardDetailsInputs = {
    detailsTextarea: document.getElementById("details-textarea"),
    lineOne: document.getElementById("customer-details-line-one"),
    lineTwo: document.getElementById("customer-details-line-two"),
    lineThree: document.getElementById("customer-details-line-three"),
  };

  const checkbox = document.getElementById("quick-details-checkbox");

  Object.keys(cardDetailsInputs).forEach((key) => {
    const input = cardDetailsInputs[key];
    if (!input || mirrorMap.has(input)) return;

    const hidden = createHiddenInputFor(input);
    hidden.name = input.value.trim()
      ? `properties[${input.name.replace("properties[", "").replace("]", "")}]`
      : "";
    hidden.value = input.value || "";

    input.addEventListener("input", () => {
      if (input.value.trim() === "") {
        hidden.value = "";
        hidden.name = "";
      } else {
        hidden.value = input.value;
        hidden.name = `properties[${input.name.replace("properties[", "").replace("]", "")}]`;
      }
    });

    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        if (key === "detailsTextarea") {
          hidden.value = "";
          hidden.name = "";
        } else {
          hidden.value = input.value;
          hidden.name = `properties[${input.name.replace("properties[", "").replace("]", "")}]`;
        }
      } else {
        if (key === "detailsTextarea") {
          hidden.value = input.value;
          hidden.name = `properties[${input.name.replace("properties[", "").replace("]", "")}]`;
        } else {
          hidden.value = "";
          hidden.name = "";
        }
      }
    });

    mirrorMap.set(input, hidden);
  });

  // --- END CUSTOM-CARD-DETAILS ---

  (function attachCardDesignMirror() {
    const cardSelect = document.getElementById("card-design");
    if (!cardSelect) return;
    let existing = Array.from(mirrorMap.keys()).find((k) => k === cardSelect);
    if (!existing) {
      const h = createHiddenInputFor(cardSelect);
      h.name = "properties[Card Design]";
      function clean(val) {
        return (val || "").replace(/graded/gi, "").trim();
      }
      h.value = clean(cardSelect.value);
      cardSelect.addEventListener("change", function () {
        const cleaned = clean(this.value);
        h.value = cleaned;
        h.name = "properties[Card Design]";
      });
      mirrorMap.set(cardSelect, h);
    }
  })();


  (function attachBundleSelector() {
    const radios = document.querySelectorAll('input[name="bundle"]');
    if (!radios.length) return;

    function getSelectedTagText() {
      const selected = document.querySelector('input[name="bundle"]:checked');
      if (!selected) return "";

      const option = selected.closest('.bundle-option');
      const span = option.querySelector('.bundle-tag');
      return span ? span.textContent.trim() : "";
    }
    
    const hiddenBundle = document.createElement("input");
    hiddenBundle.type = "hidden";
    hiddenBundle.name = "properties[Bundle Selected]";
    hiddenBundle.value = "";
    productForm.appendChild(hiddenBundle);

    const basePriceEl = document.querySelector('[data-base-price]');
    const rawBasePrice = basePriceEl ? basePriceEl.getAttribute('data-base-price') : "";

    const basePrice = rawBasePrice ? Number(rawBasePrice) / 100 : 0;

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    mirrorMap.set(radios[0], hiddenBundle);

    function getSelected() {
      return document.querySelector('input[name="bundle"]:checked');
    }

    function mirror() {
      const r = getSelected();
      if (!r) return;

      const rawBundle = r.getAttribute("data-bundle-price");
      const bundlePrice = rawBundle ? Number(rawBundle) / 100 : 0;
      const tagText = getSelectedTagText();
      hiddenBundle.value = ` ${tagText} x ${formatter.format(bundlePrice)}`;
    
    }

    mirror();
    radios.forEach((r) => r.addEventListener("change", mirror));
  })();

  // get bundleQt
  function getBundleQty() {
    const r = document.querySelector('input[name="bundle"]:checked');
    return r ? parseInt(r.getAttribute("data-qty"), 10) : 1;
  }
  function getBundleVariant() {
    const r = document.querySelector('input[name="bundle"]:checked');
    return r ? r.getAttribute("data-variant-id") : null;
  }

  // capture text inputs
  function attachGenericMirror(inputId, propertyName) {
    const input = document.getElementById(inputId);
    if (!input) return;

    if (!mirrorMap.has(input)) {
      const h_input = createHiddenInputFor(input);
      h_input.name = input.value.trim() ? `properties[${propertyName}]` : "";
      h_input.value = input.value || "";

      input.addEventListener("input", function () {
        if (this.value.trim() === "") {
          h_input.name = "";
          h_input.value = "";
        } else {
          h_input.name = `properties[${propertyName}]`;
          h_input.value = this.value;
        }
      });

      mirrorMap.set(input, h_input);
    }
  }

  (function attachCardNameMirror() {
    attachGenericMirror("customer-name", "Name");
  })();

  (function attachCardPhoneMirror() {
    attachGenericMirror("customer-phone", "Phone Number");
  })();
  //end of text inputs

  (function attachExpressServiceMirror() {
    const EXPRESS_CHECKBOX = document.getElementById(
      "quick-express-service-checkbox"
    );
    if (!EXPRESS_CHECKBOX) return;

    const EXPRESS_VARIANT_ID = 51735455269140;

   
    let existing = Array.from(mirrorMap.keys()).find((k) => k === EXPRESS_CHECKBOX);
    if (existing) return;

    const hiddenExpress = document.createElement("input");
    hiddenExpress.type = "hidden";
    hiddenExpress.name = "properties[Express Service]";
    hiddenExpress.value = "";
    productForm.appendChild(hiddenExpress);

    EXPRESS_CHECKBOX.addEventListener("change", () => {
      hiddenExpress.value = EXPRESS_CHECKBOX.checked ? "Yes" : "";
      hiddenExpress.name = EXPRESS_CHECKBOX.checked
        ? "properties[Express Service]"
        : "";
    });

  
    productForm.addEventListener("formdata", (ev) => {
      if (!EXPRESS_CHECKBOX.checked) return;
      const bundleVariant = getBundleVariant();
      if (!bundleVariant) return;

      registerExtraProduct(EXPRESS_VARIANT_ID, getBundleQty(), {
        bundleVariant
      });
    });

    
    mirrorMap.set(EXPRESS_CHECKBOX, hiddenExpress);
  })();


  (function attachPersonalAutograph() {
    const select = document.getElementById("card-autograph");
    if (!select) return;

    const AUTOGRAPH_VARIANT_ID = 51739993276692;

   
    let existing = Array.from(mirrorMap.keys()).find((k) => k === select);
    if (existing) return;

    const hiddenAutograph = document.createElement("input");
    hiddenAutograph.type = "hidden";
    hiddenAutograph.name = "properties[Add Personal Autograph]";
    hiddenAutograph.value = "";
    productForm.appendChild(hiddenAutograph);

    select.addEventListener("change", () => {
      const val = select.value;

      if (val === "Yes") {
        hiddenAutograph.value = "Yes";
        hiddenAutograph.name = "properties[Add Personal Autograph]";
      } else {
        hiddenAutograph.value = "";
        hiddenAutograph.name = "";
      }
    });

    productForm.addEventListener("formdata", (ev) => {
      const val = select.value;
      if (val !== "Yes") return;
      const bundleVariant = getBundleVariant();
      if (!bundleVariant) return;

      registerExtraProduct(AUTOGRAPH_VARIANT_ID, getBundleQty(), {
        bundleVariant
      });
    });

   
    mirrorMap.set(select, hiddenAutograph);
  })();


  // -- Card Fish -- //
  (function attachCardFish() {
    const cardSelect = document.getElementById("card-fish");
    if (!cardSelect) return;

    let existing = Array.from(mirrorMap.keys()).find((k) => k === cardSelect);
    if (existing) return;

    const h = createHiddenInputFor(cardSelect);
    h.name = "properties[_Card Fish]";

    function cleanLabel(txt) {
      return txt.replace(/\(\s*\+\s*\$.*?\)/, "").trim();
    }

    function getSelected(selectEl) {
      const opt =
        selectEl.selectedOptions && selectEl.selectedOptions[0]
          ? selectEl.selectedOptions[0]
          : null;
      if (!opt) return { label: "", variant: null };

      const label = cleanLabel(opt.textContent || opt.text || "");
      const variant =
        opt.value && opt.value.trim() !== "" ? opt.value.trim() : null;

      return { label, variant };
    }

    let { label: initLabel } = getSelected(cardSelect);
    h.value = initLabel;

    cardSelect.addEventListener("change", function () {
      const { label } = getSelected(this);
      h.value = label;
      h.name = "properties[Card Fish]";
    });

    productForm.addEventListener("formdata", (ev) => {
      const { variant } = getSelected(cardSelect);
      if (!variant || !/^\d+$/.test(variant)) return;
      const bundleVariant = getBundleVariant();
      if (!bundleVariant) return;

      registerExtraProduct(variant, getBundleQty(), {
        bundleVariant,
        _extra_for: true,
      });
    });

    mirrorMap.set(cardSelect, h);
  })();

  (function attachImageUploadMirrors() {
    const pictureInput = document.querySelector(".custom-picture-input");
    const headshotInput = document.querySelector(".custom-headshot-input");
    if (!pictureInput || !headshotInput) return;

    const pictureHidden = document.createElement("input");
    pictureHidden.type = "hidden";
    pictureHidden.name = "properties[Picture Upload]";
    productForm.appendChild(pictureHidden);

    const headshotHidden = document.createElement("input");
    headshotHidden.type = "hidden";
    headshotHidden.name = "properties[Headshot Upload]";
    productForm.appendChild(headshotHidden);

    pictureInput.addEventListener("change", () => {
      if (pictureInput.files && pictureInput.files.length > 0) {
        const url = URL.createObjectURL(pictureInput.files[0]);
        pictureHidden.value = url;
      } else {
        pictureHidden.value = "";
      }
    });

    headshotInput.addEventListener("change", () => {
      if (headshotInput.files && headshotInput.files.length > 0) {
        const url = URL.createObjectURL(headshotInput.files[0]);
        headshotHidden.value = url;
      } else {
        headshotHidden.value = "";
      }
    });
  })();

  // --- END CUSTOM CARD --- //
  function updateUploadInputsNamesBridge(orientationTitle) {
    const visibleInputsNow = getVisibleInputs();
    visibleInputsNow.forEach((v) => {
      let hidden = mirrorMap.get(v);
      if (!hidden) {
        hidden = createHiddenInputFor(v);
        mirrorMap.set(v, hidden);
        if (v.type === "file") {
          v.addEventListener("change", () => copyFilesToHidden(v, hidden));
        } else {
          v.addEventListener("input", () => {
            hidden.value = v.value;
            hidden.name = v.name;
          });
        }
      }
      if (
        v.id === "personalized-textarea" ||
        v.id === "personalized-extra-price"
      ) {
        hidden.name = v.name;
        hidden.value = v.value;
        return;
      }
      if (v.type === "file") {
        const base =
          v.dataset.baseName ||
          (v.getAttribute("name") || "").replace(/^properties\[(.*)\]$/, "$1");
        const sanitizedBase = base
        ? String(base)
            .split("-")[0]
            .replace(/[\[\]\=<>]/g, "")
            .trim()
        : "";

        if (!sanitizedBase) {
          hidden.name = "";
          return;
        }
        if (!orientationTitle) {
          hidden.name = `properties[${sanitizedBase}]`;
        } else {
          const orientationSafe = String(orientationTitle)
            .replace(/[\[\]\=<>]/g, "")
            .trim();
          hidden.name = `properties[${sanitizedBase} - ${orientationSafe}]`;
        }
        if (v.files && v.files.length) copyFilesToHidden(v, hidden);
      }
    });
    Array.from(mirrorMap.keys()).forEach((v) => {
      if (!document.body.contains(v)) {
        const h = mirrorMap.get(v);
        if (h && h.parentNode) h.parentNode.removeChild(h);
        mirrorMap.delete(v);
      }
    });
  };

  // Custom Framed Design (Jerseys and Pictures);
  (function attachTopMatteMirror() {
    const drop = document.querySelector(
      '#top_matte_colors .color-dropdown[data-name="top_matte_color"]'
    );
    if (!drop) return;

    const hiddenSource = drop.querySelector('input[type="hidden"]');
    if (!hiddenSource) return;

    let existing = Array.from(mirrorMap.keys()).find(k => k === hiddenSource);
    if (!existing) {
      const h = createHiddenInputFor(hiddenSource);
      h.name = "properties[Top Matte Color]";

      function getLabel() {
        const selected = drop.querySelector('.selected');
        if (!selected) return "";
        const name = selected.textContent.trim();
        const hex = hiddenSource.value;
        return hex ? `${name} (${hex})` : name;
      }

      h.value = getLabel();

      const observer = new MutationObserver(() => {
        h.value = getLabel();
        h.name = "properties[Top Matte Color]";
      });

      observer.observe(hiddenSource, {
        attributes: true,
        attributeFilter: ["value"]
      });

      mirrorMap.set(hiddenSource, h);
    }
  })();

  (function attachBottomMatteMirror() {
    const drop = document.querySelector(
      '#bottom_matte_colors .color-dropdown[data-name="bottom_matte_color"]'
    );
    if (!drop) return;

    const hiddenSource = drop.querySelector('input[type="hidden"]');
    if (!hiddenSource) return;

    let existing = Array.from(mirrorMap.keys()).find(k => k === hiddenSource);
    if (!existing) {
      const h = createHiddenInputFor(hiddenSource);
      h.name = "properties[Bottom Matte Color]";

      function getLabel() {
        const selected = drop.querySelector('.selected');
        if (!selected) return "";
        const name = selected.textContent.trim();
        const hex = hiddenSource.value;
        return hex ? `${name} (${hex})` : name;
      }

      h.value = getLabel();

      const observer = new MutationObserver(() => {
        h.value = getLabel();
        h.name = "properties[Bottom Matte Color]";
      });

      observer.observe(hiddenSource, {
        attributes: true,
        attributeFilter: ["value"]
      });

      mirrorMap.set(hiddenSource, h);
    }
  })();

  (function attachPlateColorMirror() {
    const drop = document.querySelector(
      '#plate_colors .color-dropdown[data-name="plate_color"]'
    );
    if (!drop) return;

    const hiddenSource = drop.querySelector('input[type="hidden"]');
    if (!hiddenSource) return;

    let existing = Array.from(mirrorMap.keys()).find(k => k === hiddenSource);
    if (!existing) {
      const h = createHiddenInputFor(hiddenSource);
      h.name = "properties[Plate Color]";

      function getLabel() {
        const selected = drop.querySelector('.selected');
        if (!selected) return "";
        const name = selected.textContent.trim();
        const hex = hiddenSource.value;
        return hex ? `${name} (${hex})` : name;
      }

      h.value = getLabel();

      const observer = new MutationObserver(() => {
        h.value = getLabel();
        h.name = "properties[Plate Color]";
      });

      observer.observe(hiddenSource, {
        attributes: true,
        attributeFilter: ["value"]
      });

      mirrorMap.set(hiddenSource, h);
    }
  })();

  (function attachFrameDesignMirror() {
    const frameSelect = document.getElementById("frame-design");
    if (!frameSelect) return;

    let existing = Array.from(mirrorMap.keys()).find((k) => k === frameSelect);
    if (existing) return;

    const hidden = createHiddenInputFor(frameSelect);
    hidden.name = "properties[Frame Design]";
    hidden.value = frameSelect.value;

    frameSelect.addEventListener("change", function () {
      hidden.value = this.value;
      hidden.name = "properties[Frame Design]";
    });

    mirrorMap.set(frameSelect, hidden);
  })();

  (function attachFrameColorMirror() {
    const frameSelect = document.getElementById("frame-color");
    if (!frameSelect) return;

    let existing = Array.from(mirrorMap.keys()).find((k) => k === frameSelect);
    if (existing) return;

    const hidden = createHiddenInputFor(frameSelect);
    hidden.name = "properties[Frame Color]";
    hidden.value = frameSelect.value;

    frameSelect.addEventListener("change", function () {
      hidden.value = this.value;
      hidden.name = "properties[Frame Color]";
    });

    mirrorMap.set(frameSelect, hidden);
  })();

  (function attachJerseysDesignMirror() {
    const frameSelect = document.getElementById("jerseys-design");
    if (!frameSelect) return;

    let existing = Array.from(mirrorMap.keys()).find((k) => k === frameSelect);
    if (existing) return;

    const hidden = createHiddenInputFor(frameSelect);
    hidden.name = "properties[Jersey Design]";
    hidden.value = frameSelect.value;

    frameSelect.addEventListener("change", function () {
      hidden.value = this.value;
      hidden.name = "properties[Jersey Design]";
    });

    mirrorMap.set(frameSelect, hidden);
  })();

  function injectSharedProperties(ev, itemIndex) {
    const entries = Array.from(mirrorMap.entries());
    entries.forEach(([visible, hidden]) => {
      if (!hidden || !hidden.name) return;
      const match = hidden.name.match(/properties\[(.+?)\]/);
      if (!match) return;
      const propName = match[1];

      if (visible.type === "file") {
        const files = visible.files;
        if (!files || files.length === 0) return;
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          ev.formData.append(
            `items[${itemIndex}][properties][${propName}]`,
            file,
            file.name,
          );
        }
        return;
      }

      const value = hidden.value;
      if (value && String(value).trim()) {
        ev.formData.append(
          `items[${itemIndex}][properties][${propName}]`,
          value,
        );
      }
    });
  };


  function getPhotoOrientationValue(){
      const checked = document.querySelector('input[name="Photo Orientation"]:checked');
     
      if(checked && checked.value) return checked.value;
      
      return "landscape"
  };

  // to add extra price for personalized text, custom framed jerseys:
  // function resolvePersonalizedVariantId() {
  //   const toggle = document.querySelector("#personalized-toggle");
  //   if (toggle && toggle.checked) {
  //     return "51803637907732";
  //   }
  //   return "51799046684948";
  // }
    // function resolvePersonalizedVariantId(productForm) {
    //         if (
    //       !window.ShopifyAnalytics ||
    //       !ShopifyAnalytics.meta ||
    //       !ShopifyAnalytics.meta.product ||
    //       ShopifyAnalytics.meta.product.handle !== "custom-framed-jerseys"
    //     ) {
    //       return null;
    //     }

    //     const toggle = document.querySelector("#personalized-toggle");

    //     if (toggle && toggle.checked) {
    //       return "51803637940500"
    //       // return "51803637907732";
    //     }
    //     return "51799046717716"
    //     // return "51799046684948";
    // }

  function getSelectedJerseyMount() {
    const checked = document.querySelector(
      'fieldset[data-handle="jersey-mount"] input[type="radio"]:checked'
    );
    return checked ? checked.value : null;
  }


  // UNCOMENT IF WANT TO ADD VARIANT EXTRA VALUES FOR CUSTOM JERSEYS PRODUCTS
  // remember to change the variant ids for the code to work.
  // function resolveFinalVariantId() {
  //   const mount = getSelectedJerseyMount();
  //   const toggle = document.querySelector("#personalized-toggle");
  //   const personalized = toggle && toggle.checked;

  //   if (mount === "Front Facing" && !personalized) return "51799046717716";
  //   if (mount === "Front Facing" && personalized) return "51803637940500";
  //   if (mount === "Back Facing" && !personalized) return "51799046783252";
  //   if (mount === "Back Facing" && personalized) return "51803638006036";

  //   return null;
  // }


  productForm.addEventListener("formdata", (ev) => {
    // uncommnet if you want extra prices for Custom products.
    //  const id = resolveFinalVariantId();
    //   if (id) {
    //     ev.formData.set("id", id);
    //   }
    // end/

      const r = document.querySelector('input[name="bundle"]:checked');
      const submissionId = crypto.randomUUID();

      window.__lastSubmissionId = submissionId;

      const bundleVariant = r ? r.getAttribute("data-variant-id") : null;
      const qty = r ? r.getAttribute("data-qty") : null;

      if (r) {
        ev.formData.delete("id");
        ev.formData.delete("quantity");

        ev.formData.set(`items[0][id]`, bundleVariant);
        ev.formData.set(`items[0][quantity]`, qty);

        injectSharedProperties(ev, 0);

        ev.formData.set(`items[0][properties][_bundle_instance]`, submissionId);
        ev.formData.set(`items[0][properties][_bundle_variant]`, bundleVariant);
        ev.formData.set(`items[0][properties][_bundle_parent_key]`, submissionId);
      }

      extraProducts.forEach((p) => {
        if (!p.props) p.props = {};
        p.props.bundleInstance = submissionId;
      });

      const extrasForThisBundle = extraProducts.filter(
        (p) => p.props && p.props.bundleInstance === submissionId
      );

      extrasForThisBundle.forEach((p, i) => {
        const idx = i + 1;

        ev.formData.set(`items[${idx}][id]`, p.variantId);
        ev.formData.set(`items[${idx}][quantity]`, p.qty);

        const props = p.props || {};

        Object.keys(props).forEach((key) => {
          ev.formData.set(`items[${idx}][properties][_${key}]`, props[key]);
        });

        ev.formData.set(`items[${idx}][properties][_extra_for]`, submissionId);
        ev.formData.set(`items[${idx}][properties][_bundle_instance]`, submissionId);

        ev.formData.set(`items[${idx}][properties][_bundle_parent_key]`, submissionId);
      });

      extraProducts.length = 0;
  });



  document.querySelectorAll("[data-custom-toggle]").forEach((toggle) => {
    toggle.addEventListener("change", () => {
      const target = toggle.dataset.target;
      // const checkedOrient = document.querySelector(
      //   'input[name="Photo Orientation"]:checked',
      // );
      // const orientVal = checkedOrient ? checkedOrient.value : null;
      const orientVal = getPhotoOrientationValue();

      const orientationTitle =
        orientVal && orientVal.toLowerCase().includes("portrait")
          ? "Portrait"
          : orientVal && orientVal.toLowerCase().includes("landscape")
            ? "Landscape"
            : null;
      if (toggle.checked) {
        updateUploadInputsNamesBridge(orientationTitle);
      } else {
        if (!target) return;
        productForm
          .querySelectorAll(`.custom-mirror-input[data-origin="${target}"]`)
          .forEach((m) => {
            m.name = "";
            try {
              if (m.type === "file") m.files = new DataTransfer().files;
            } catch (_) {}
          });
      }
    });
  });

  window.syncCustomPhotoUploadsToForm = updateUploadInputsNamesBridge;

  updateUploadInputsNamesBridge(null);

  const container = document.querySelector("[data-product-blocks]") || document.body;
  const mo = new MutationObserver(() => {
    const newVisibleInputs = getVisibleInputs();
    newVisibleInputs.forEach((v) => {
      if (!mirrorMap.has(v)) {
        const h = createHiddenInputFor(v);
        mirrorMap.set(v, h);
        if (v.type === "file") {
          v.addEventListener("change", () => copyFilesToHidden(v, h));
        } else {
          v.addEventListener("input", () => {
            h.value = v.value;
            h.name = v.name;
          });
        }
      }
    });
    // const checked = document.querySelector(
    //   'input[name="Photo Orientation"]:checked',
    // );
    // const orientVal = checked ? checked.value : null;
    const orientVal = getPhotoOrientationValue();
  

    const orientationTitle =
      orientVal && orientVal.toLowerCase().includes("portrait")
        ? "Portrait"
        : orientVal && orientVal.toLowerCase().includes("landscape")
          ? "Landscape"
          : null;
    updateUploadInputsNamesBridge(orientationTitle);
  });

  mo.observe(container, { childList: true, subtree: true });
});